import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./ClientAccessSetupTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUndo, faPen, faMinus, faTimes, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { PopupMessage } from "../../utils/utils";
import { clientAccess, clientId } from "../../utils/index";
import styles from "../master.css";
import Popup from "reactjs-popup";
import apiUrl from "../../apiUrlConstant";
import SimpleReactValidator from "simple-react-validator";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";


var validationRules = {
  email: Yup.string().required("Required"),
  mobile: Yup.string().required("Required"),


  name: Yup.string().required("Required"),
};
//console.log(clientId(), "adas");
if (clientId() != 0) {
  validationRules = {
    //clientName: Yup.string().required("Required"),
    //clientGroup: Yup.string().required("Required"),
    //role: Yup.string().required('Required'),
    email: Yup.string().required("Required"),
    mobile: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
  };
}

const formValidationFields = Yup.object().shape(validationRules);

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class ClientAccessSetup extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    popupContent: "",
    messsagePopup: false,
    redirect: false,
    id: undefined,
    url: `${apiUrl.apiUrl.url}/client/create-access-setup`,
    countries: [],
    states: [],
    cityList: [],
    brandList: [],
    delete: false,
    initialValues: {
      brandId: [],
      cityId: [],
      countryId: [],
      clientId: "",
      clientName: "",
      groupId: "",
      groupName: "",
      clientGroup: "",
      role: "admin",
      roleName: "Admin",
      email: "",
      name: "",
      mobile: "",
    },
    readOnly: false,
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-brand-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

  };
  checkDelete() {
    var self = this;
    self.setState({
      delete: true
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/client/create-access-setup`,
          initialValues: {
            clientId: "",
            clientName: "",
            groupId: "",
            groupName: "",
            clientGroup: "",
            role: "admin",
            roleName: "Admin",
            email: "",
            name: "",
            mobile: "",
          },
        });
      } else {

        let athis = this;
        axios({
          method: "get",
          url: `${apiUrl.apiUrl.url}/client/fetch-client-setup?id=${this.props.match.params.id}`,
          headers: headers,
        }).then(function (response) {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/client/update-access-setup?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            clientList: data.client_list,
            readOnly: true,
          });

          athis.state.initialValues.countryId =
            data.form_data.countryId.countryId;
          athis.state.initialValues.countryName =
            data.form_data.countryId.countryName;
          athis.state.stateSelected = data.form_data.stateId;
          athis.state.initialValues.stateId = data.form_data.stateArr;
          athis.state.citySeleted = data.form_data.cityId;
          athis.state.initialValues.cityId = data.form_data.cityArr;
          athis.state.brandSelected = data.form_data.brandId;
          athis.state.initialValues.brandId = data.form_data.brandArr;

          athis.state.cityList = data.form_data.cities;
          athis.state.states = data.form_data.state;
          athis.state.countries = data.form_data.countries;
          athis.state.brandList = data.form_data.brands;
        });

        this.setState({});

        // fetch(
        //   `${apiUrl.apiUrl.url}/client/fetch-client-setup?id=${this.props.match.params.id}`, { headers }
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/client/update-access-setup?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       clientList: data.client_list,
        //       readOnly: true,
        //     });

        //     this.state.initialValues.countryId =
        //       data.form_data.countryId.countryId;
        //     this.state.initialValues.countryName =
        //       data.form_data.countryId.countryName;
        //     this.state.stateSelected = data.form_data.stateId;
        //     this.state.initialValues.stateId = data.form_data.stateArr;
        //     this.state.citySeleted = data.form_data.cityId;
        //     this.state.initialValues.cityId = data.form_data.cityArr;
        //     this.state.brandSelected = data.form_data.brandId;
        //     this.state.initialValues.brandId = data.form_data.brandArr;

        //     this.state.cityList = data.form_data.cities;
        //     this.state.states = data.form_data.state;
        //     this.state.countries = data.form_data.countries;
        //     this.state.brandList = data.form_data.brands;
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
        // this.setState({});

      }
    }
  }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  handleRoleChange = (newValue, actionMeta) => {
    this.state.initialValues.role = newValue.value;
    this.state.initialValues.roleName = newValue.label;
    this.setState({});
  };

  handleChangeCountry = (newValue, actionMeta) => {
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = [];
    this.state.initialValues.stateName = "";
    this.state.initialValues.cityId = [];
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.cityId = [];
      this.state.initialValues.cityName = "";

      this.state.stateSelected = [];
      this.state.initialValues.stateId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.stateId.push(newValue[i].value);
        this.state.stateSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      fetch(
        `${apiUrl.apiUrl.url}/city/state-cities?stateId=` +
        this.state.initialValues.stateId,
        {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_city") {
      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      this.state.citySeleted = [];
      this.state.initialValues.cityId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.cityId.push(newValue[i].value);
        this.state.citySeleted.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
    } else if (actionMeta == "change_brand") {
      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      console.log(this.state.initialValues, "this.state.initialValues");
    }
    this.setState({});
  };

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };
  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/client/delete?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      clientId: "",
      clientName: "",
      groupId: "",
      groupName: "",
      clientGroup: "",
      role: "admin",
      roleName: "Admin",
      email: "",
      name: "",
      mobile: "",
      //countries: [],
      //states: [],
      //cityList: [],
      //brandList: [],
      stateSelected: [],
      citySeleted: [],
      brandSelected: [],
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      clientId: "",
      clientName: "",
      groupId: "",
      groupName: "",
      clientGroup: "",
      role: "admin",
      roleName: "Admin",
      email: "",
      name: "",
      mobile: "",
      //countries: [],
      //states: [],
      //cityList: [],
      //brandList: [],
      stateSelected: [],
      citySeleted: [],
      brandSelected: [],
    });
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-access-setup" />;
    }
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/masters/client-directory">Client Profile</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/#">Client Access Setup</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="parentContainer">
          {this.renderForm()}
        </div>
      </>
    );
  }

  renderForm() {
    return (
      <>


        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={formValidationFields}
          onSubmit={(values, actions) => {
            if (!this.validator.allValid()) {
              this.validator.showMessages();
              return false;
            }
            //values.groupId = this.groupId.value;
            //alert(JSON.stringify(values, null, 2));
            values.role = this.state.initialValues.role;
            values.roleName = this.state.initialValues.roleName;
            console.log(values, "==", this.state.initialValues);
            var self = this;
            axios({
              method: "post",
              url: `${this.state.url}`, // `${apiUrl.apiUrl.url}/client/create-access-setup`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                for (const [key, value] of Object.entries(
                  self.state.initialValues
                )) {
                  self.state.initialValues[key] = "";
                }
                self.state.brandSelected = "";
                self.state.citySeleted = "";
                self.state.stateSelected = "";

                self.setState({});
                // self.setState({ redirect: true });
                // alert("Data Saved Successfully");
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="newGridSectionParent">
                  <div className="newGridSectionForFormMain">
                    {clientAccess() &&
                      <div className="newGridSectionInner">
                        <label>
                          Client Group <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="clientGroup"
                            onChange={(e) => {
                              this.handleChangeLandlordGroup(
                                e,
                                "change_client_group"
                              );
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.LandlordGroups.map(
                              (item) => ({
                                label: item.group_name,
                                value: item.id,
                              })
                            )}
                          />
                        </div>
                      </div>
                    }
                    {clientAccess() &&
                      <div className="newGridSectionInner">
                        <label>
                          Client Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="clientName"
                            onChange={(e) => {
                              this.handleChangeLandlordGroup(
                                e,
                                "change_client_name"
                              );
                            }}
                            value={{
                              label: this.state.initialValues.clientName,
                              value: this.state.initialValues.clientId,
                            }}
                            options={this.state.clientList.map((item) => ({
                              label: item.client_name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>
                    }
                    <div className="newGridSectionInner">
                      <label>
                        Name <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field type="text" name="name" />

                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Role <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          name="role"
                          //onInputChange={this.handleChange}
                          onChange={(e) => {
                            this.handleRoleChange(e);
                          }}
                          value={{
                            label: this.state.initialValues.roleName,
                            value: this.state.initialValues.role,
                          }}
                          options={[
                            { id: "admin", label: "Admin" },
                            { id: "user", label: "User" },
                            { id: "checker", label: "Checker" },
                            { id: "maker", label: "Maker" }
                          ].map((item) => ({
                            label: item.label,
                            value: item.id,
                          }))}
                        />
                        {this.validator.message(
                            "Role",
                            this.state.initialValues.role,
                            "required",
                            { className: "text-danger" }
                          )}
                        <ErrorMessage
                          name="role"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>Email <span className="astrik">*</span></label>
                      <div className="position-relative">
                        {this.state.readOnly ? (
                          <Field
                            type="email"
                            name="email"
                          />
                        ) : (
                          <Field type="email" name="email" />
                        )}

                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>Mobile <span className="astrik">*</span></label>
                      <div className="position-relative">
                        <Field type="number" name="mobile" onChange={handleChange} />
                        <ErrorMessage
                          name="mobile"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>Country</label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          name="countryId"
                          isSearchable="true"
                          onChange={(e) => {
                            this.handleChangeCountry(e, "changecountry");
                          }}
                          value={{
                            label: this.state.initialValues.countryName,
                            value: this.state.initialValues.countryId,
                          }}
                          options={this.state.countries.map((item) => ({
                            label: item.country_name,
                            value: item.id,
                          }))}
                        />

                        <ErrorMessage
                          name="countryId"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>State</label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          name="stateId"
                          isMulti
                          // onInputChange={this.handleChange}
                          // onChange={}
                          onChange={(e) => {
                            //handleChange(e);
                            this.valueChange(e, "change_state");
                          }}
                          value={this.state.stateSelected}
                          options={this.state.states.map((item) => ({
                            label: item.state_name,
                            value: item.id,
                          }))}
                        />

                        <ErrorMessage
                          name="stateId"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>City</label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          name="cityId"
                          isMulti
                          // onInputChange={this.handleChange}
                          // onChange={}
                          onChange={(e) => {
                            //handleChange(e);
                            this.valueChange(e, "change_city");
                          }}
                          value={this.state.citySeleted}
                          options={this.state.cityList.map((item) => ({
                            label: item.city_name,
                            value: item.id,
                          }))}
                        />

                        <ErrorMessage
                          name="cityId"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>Brand Name</label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          name="brandId"
                          isMulti
                          closeMenuOnSelect={false}
                          onInputChange={this.handleChange}
                          // onChange={}
                          onChange={(e) => {
                            this.valueChange(e, "change_brand");
                          }}
                          value={this.state.brandSelected}
                          options={this.state.brandList.map((item) => ({
                            label: item.brand_name,
                            value: item.id,
                          }))}
                        />

                        <ErrorMessage
                          name="brandId"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                  </div>

                  {this.props.match.params.id !== undefined ? (
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="update_button" disabled={isSubmitting}>
                        Update
                      </button>
                      <button
                        className="delete_button"
                        type="button"
                        onClick={(e) => {
                          this.checkDelete(e);
                        }}>
                        Delete
                      </button>
                      <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                        <Link to="/masters/client-access-setup">
                          Reset
                        </Link>
                      </button>
                    </div>
                  ) : (
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button" disa1bled={isSubmitting}>
                        Add
                      </button>
                      <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                        Reset
                      </button>
                    </div>
                  )}
                  {/* </div> */}
                </div>
              </Form>
            </div >
          )
          }
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Table />
      </>
    );
  }
}

export default withRouter(ClientAccessSetup);
